export const professionalEmails = {
  general: 'hello@nexlineglobal.tech',
  support: 'support@nexlineglobal.tech',
  privacy: 'privacy@nexlineglobal.tech',
  security: 'security@nexlineglobal.tech',
  api: 'api@nexlineglobal.tech',
  billing: 'billing@nexlineglobal.tech',
  sales: 'sales@nexlineglobal.tech',
  admin: 'admin@nexlineglobal.tech',
} as const

export type ProfessionalEmailKey = keyof typeof professionalEmails
